'use client';

import { motion, useScroll, useSpring, useTransform } from 'framer-motion';

export default function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 300,
    damping: 40,
    restDelta: 0.001,
  });
  const width = useTransform(smoothProgress, (v) => `${v * 100}%`);

  return <motion.div className="scroll-progress" id="scroll-progress" style={{ width }} />;
}
